<template>
  <div ref="dom" class="charts chart-pie"></div>
</template>

<script>
import * as echarts from "echarts";
import { on, off } from "@/libs/tools";
export default {
  name: "ChartPie",
  props: {
    value: Array,
    text: String,
    subtext: String,
  },
  data() {
    return {
      dom: null,
      title: "",
      subTitle: "",
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal.length) {
          this.loadEcharts(newVal);
        }
      },
      deep: true,
      immediate: true,
    },
    subtext: {
      handler(val) {
        // console.log(val)
        if (val == "") {
          this.title = "";
        } else {
          this.title = "男女比例";
        }
        this.titleText = val;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    resize() {
      this.dom.resize();
    },
    loadEcharts(val) {
      this.$nextTick(() => {
        let option = {
          color: ["#16d0c8", "#ffc000", "#ff5b82"],
          title: {
            text: this.title,
            subtext: this.subtext,
            textStyle: {
              fontSize: 18,
              fontFamily: "SourceHanSansCN-Medium",
              color: "#333",
            },
            subtextStyle: {
              fontSize: 22,
              fontFamily: "SourceHanSansCN-Medium",
              color: "#333",
            },
            x: "center",
            y: "32%",
          },
          tooltip: {
            trigger: "item",
          },
         grid: {
            left: "3%",
            right: "3%",
            top: "15%",
            bottom: "10%",
            containLabel: true,
          },
          legend: {
            bottom: "8%",
            left: "center",
            icon: "circle",
            formatter: function (name) {
              console.log(val);
              let leg = val.filter((item) => item.name == name);
              let legendName = name + "  " + leg[0].value;
              // name + "  " + ((leg[0].value / total) * 100).toFixed(2) + "%";
              return legendName;
            },
          },
          series: [
            {
              name: "新生男女比例",
              type: "pie",
              center: ["50%", "40%"],
              radius: ["50%", "58%"],
              avoidLabelOverlap: false,
              itemStyle: {
                // borderRadius: 10,
                borderColor: "#fff",
                borderWidth: 2,
              },
              label: {
                show: true,
                position: "outside",
                padding: [0, -80],
                formatter: "{b} : {c} \n",
              },
              labelLine: {
                show: true,
                length: 20,
                length2: 80,
                align: "right",
                lineStyle: {
                  width: 1,
                },
              },
              // emphasis: {
              //   label: {
              //     show: false,
              //     fontSize: "40",
              //     fontWeight: "bold",
              //   },
              // },
              data: val,
            },
          ],
        };
        if (this.dom != null && this.dom != "" && this.dom != undefined) {
          this.dom.dispose();
        }
        this.dom = echarts.init(this.$refs.dom);
        this.dom.setOption(option);
        on(window, "resize", this.resize);
      });
    },
  },

  beforeDestroy() {
    off(window, "resize", this.resize);
  },
};
</script>
